"use client";

import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { baseUrl, localUrl } from "../../config/baseUrl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import toastify from "../../config/toastify";

export function formatDescription(html) {
  if (!html) return "N/A";

  // Regex to match URLs (http, https, www)
  const urlRegex = /(https?:\/\/[^\s<>]+)|(www\.[^\s<>]+)/g;

  // Replace plain URLs with <a> tags
  const formattedHtml = html.replace(urlRegex, (url) => {
    const href = url.startsWith("http") ? url : `http://${url}`;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });

  return formattedHtml;
}

export default function ViewFullNews() {
  const { id } = useParams();
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (id) {
      fetchDetails();
    }
  }, [id]);

  // console.log("animalData", animalData)

  const fetchDetails = async () => {
    setLoading(true);
    try {
      // Fetch package list
      const response = await axios.get(
        // `${localUrl}/admin/news/${id}`,
        `${baseUrl}/admin/news/${id}`,

        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      // console.log("res", response)

      if (response?.data.status && response?.status === 200) {
        // Find the specific package by ID
        const packageData = response?.data?.data || null;

        if (packageData) {
          setUserData(packageData);
        } else {
          toastify.error("Animal not found");
        }
      }
    } catch (error) {
      console.error("Error fetching Animal data:", error);
      toastify.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  function linkify(text) {
    if (!text) return "N/A";

    // Regex to detect URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Replace URLs with <a> tags
    return text.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  }

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "400px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // if (!packageData) {
  //     return (
  //         <div className="text-center" style={{ minHeight: "400px", paddingTop: "100px" }}>
  //             <h4>Package not found</h4>
  //         </div>
  //     )
  // }

  return (
    <>
      <style jsx>{`
        .main-sec {
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
          min-height: 100vh;
          padding: 2rem;
        }

        .dashboard-title {
          margin-bottom: 1.5rem;
        }

        .dash-head {
          color: #333;
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0;
        }

        .cards {
          background: white;
          border-radius: 15px;
          padding: 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
          margin-bottom: 2rem;
        }

        .package-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 2rem;
          margin-bottom: 2rem;
          padding-bottom: 2rem;
          border-bottom: 1px solid #eee;
        }

        .package-header .left {
          display: flex;
          align-items: center;
          gap: 2rem;
        }

        .package-image {
          width: 200px;
          height: 200px;
          border-radius: 15px;
          object-fit: cover;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        }

        .package-info h2 {
          color: #333;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .package-info p {
          color: #666;
          font-size: 1.1rem;
          line-height: 1.6;
          margin-bottom: 1.5rem;
        }

        .status-badge {
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.9rem;
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
        }

        .status-active {
          background: #d4edda;
          color: #155724;
        }

        .status-inactive {
          background: #f8d7da;
          color: #721c24;
        }

        .detail-section {
          background: #f8f9ff;
          border-radius: 10px;
          padding: 1.5rem;
          margin-bottom: 2rem;
          border-left: 4px solid #667eea;
        }

        .section-title {
          color: #667eea;
          font-weight: 700;
          margin-bottom: 1rem;
          font-size: 1.1rem;
        }

        .detail-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
        }

        .detail-item {
          background: white;
          padding: 1rem;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }

        .detail-label {
          font-weight: 600;
          color: #555;
          font-size: 0.9rem;
          margin-bottom: 0.5rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .detail-value {
          font-size: 1.1rem;
          color: #333;
          font-weight: 500;
          word-wrap: break-word;
          overflow-wrap: break-word;
          max-height: 400px;
          overflow-y: auto;
          white-space: pre-wrap;
        }

        .price-value {
          font-size: 1.5rem;
          font-weight: 700;
          color: #667eea;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .btn-edit {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          border-radius: 8px;
          padding: 0.75rem 1.5rem;
          color: white;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .btn-edit:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
          color: white;
        }

        .btn-back {
          background: #4facfe;
          border: none;
          border-radius: 8px;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .btn-back:hover {
          background: #2f86fe;
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(79, 172, 254, 0.3);
        }

        .no-image {
          width: 200px;
          height: 200px;
          border-radius: 15px;
          background: #f8f9fa;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #999;
          font-size: 3rem;
          border: 2px dashed #ddd;
        }

        .video-wrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .video-player {
          // border-radius: 12px;
          // box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
        }

        @media (max-width: 768px) {
          .package-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
          }

          .package-image,
          .no-image {
            width: 150px;
            height: 150px;
          }

          .detail-grid {
            grid-template-columns: 1fr;
          }

          .cards {
            padding: 1.5rem;
          }
        }
      `}</style>

      <section className="main-sec">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="dashboard-title">
                <h4 className="dash-head">News Details</h4>
              </div>
              <div className="custom-bredcump">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/news-list">News List</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      View Details
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="col-lg-6 d-flex justify-content-end gap-2">
              <Link to="/news-list" className="btn btn-back text-white">
                <FontAwesomeIcon icon={faArrowLeft} className="me-1" />
                Back
              </Link>
              {/* <Link
                to={`/animals-list/edit/${animalData._id}`}
                className="btn-edit"
              >
                <FontAwesomeIcon icon={faEdit} className="me-1" />
                Edit Details
              </Link> */}
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="cards">
                <div className="package-header">
                  <div className="left">
                    <img
                      // src={`${localUrl}/${userData.photo}`}
                      src={`${baseUrl}/${userData.first_image}`}
                      alt={userData.name}
                      className="package-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/appicon.png";
                      }}
                    />
                    <div className="package-info">
                      {/* <h2 className="mb-2 text-capitalize">
                      {animalData.animalname}
                    </h2> */}
                      <p className="mb-1">
                        <strong>Title:</strong> {userData.title}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="detail-section">
                  <h5 className="section-title">Description</h5>
                  <div className="detail-grid">
                    <div className="detail-item">
                      <div
                        className="detail-value"
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            formatDescription(userData.description) || "N/A",
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="detail-section">
                  <h5 className="section-title">Other Details</h5>
                  <div className="detail-grid">
                    <div className="detail-item">
                      <div className="detail-label">WebSite</div>
                      <div className="detail-value">
                        {userData.website || "N/A"}
                      </div>
                    </div>
                    <div className="detail-item">
                      <div className="detail-label">User Id</div>
                      <div className="detail-value">
                        {userData.user_id || "N/A"}
                      </div>
                    </div>
                    <div className="detail-item">
                      <div className="detail-label">Total Count</div>
                      <div className="detail-value">
                        {userData.total_count || "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
